import React, { useState } from 'react';
import StaticPageLayout from '@/components/layout/StaticPageLayout';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Mail, Phone } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';
const ContactPage = () => {
  const {
    toast
  } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      id,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const {
        error
      } = await supabase.functions.invoke('send-contact-email', {
        body: formData
      });
      if (error) throw error;
      toast({
        title: "Message sent",
        description: "Thank you for contacting us. We'll get back to you soon."
      });

      // Reset form
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      console.error('Error submitting form:', error);
      toast({
        title: "Failed to send message",
        description: "Please try again later or contact us directly via email.",
        variant: "destructive"
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  return <StaticPageLayout title="Contact Us" description="Get in touch with the Everhouse team">
      <div className="grid md:grid-cols-2 gap-12">
        <section>
          <h2 className="text-2xl mb-6 font-normal">Contact Information</h2>
          <div className="space-y-4 mb-8">
            <div className="flex items-center gap-2">
              <Mail className="h-5 w-5" />
              <a href="mailto:contact@everhouse.co" className="hover:underline">
                contact@everhouse.co
              </a>
            </div>
            
          </div>

          <div className="space-y-6">
            <div>
              <h3 className="mb-2 font-normal">Press Enquiries</h3>
              <p className="text-muted-foreground">
                For press-related inquiries, please email{' '}
                <a href="mailto:enquiries@everhouse.co" className="underline">enquiries@everhouse.co</a>
              </p>
            </div>

            <div>
              <h3 className="mb-2 font-normal">Business Development</h3>
              <p className="text-muted-foreground">
                For partnership opportunities, contact{' '}
                <a href="mailto:partnerships@everhouse.co" className="underline">
                  partnerships@everhouse.co
                </a>
              </p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="text-2xl mb-6 font-normal">Send Us a Message</h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium mb-2">
                Name
              </label>
              <Input id="name" value={formData.name} onChange={handleChange} required />
            </div>
            
            <div>
              <label htmlFor="email" className="block text-sm font-medium mb-2">
                Email
              </label>
              <Input id="email" type="email" value={formData.email} onChange={handleChange} required />
            </div>
            
            <div>
              <label htmlFor="subject" className="block text-sm font-medium mb-2">
                Subject
              </label>
              <Input id="subject" value={formData.subject} onChange={handleChange} required />
            </div>
            
            <div>
              <label htmlFor="message" className="block text-sm font-medium mb-2">
                Message
              </label>
              <Textarea id="message" rows={5} value={formData.message} onChange={handleChange} required />
            </div>

            <Button type="submit" disabled={isSubmitting} className="w-full bg-emerald-400 hover:bg-emerald-300">
              {isSubmitting ? 'Sending...' : 'Send Message'}
            </Button>
          </form>
        </section>
      </div>
    </StaticPageLayout>;
};
export default ContactPage;